var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnlockModalIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.7701 5.64136V7.04456C20.7701 7.26164 20.324 7.43752 19.7733 7.43752C19.2231 7.43752 18.7766 7.26164 18.7766 7.04456V5.64136C18.7766 3.62962 17.1401 1.99359 15.1288 1.99359C13.1175 1.99359 11.481 3.62962 11.481 5.64136V10.7105C11.481 10.9276 11.0344 11.1035 10.4842 11.1035C9.93354 11.1035 9.48743 10.9276 9.48743 10.7105V5.64136C9.48747 2.5305 12.018 0 15.1288 0C18.2396 0 20.7701 2.5305 20.7701 5.64136Z",
    fill: "url(#paint0_linear_61_1395)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1288 0C15.0484 0 14.9685 0.00210937 14.8889 0.0054375V2.00231C14.9683 1.99711 15.0482 1.99355 15.1288 1.99355C17.1401 1.99355 18.7766 3.62958 18.7766 5.64131V7.04452C18.7766 7.26159 19.2232 7.43747 19.7734 7.43747C20.3241 7.43747 20.7702 7.26159 20.7702 7.04452V5.64131C20.7702 2.5305 18.2397 0 15.1288 0Z",
    fill: "url(#paint1_linear_61_1395)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4842 11.1035C11.0344 11.1035 11.481 10.9277 11.481 10.7106V5.64143C11.481 5.48191 11.4924 5.32507 11.5123 5.1709H9.50721C9.49432 5.3261 9.48743 5.48295 9.48743 5.64143V10.7106C9.48743 10.9277 9.93354 11.1035 10.4842 11.1035Z",
    fill: "url(#paint2_linear_61_1395)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7766 5.64143V7.04463C18.7766 7.26171 19.2231 7.43759 19.7733 7.43759C20.324 7.43759 20.7701 7.26171 20.7701 7.04463V5.64143C20.7701 5.48295 20.7633 5.3261 20.7504 5.1709H18.7452C18.7651 5.32507 18.7766 5.48187 18.7766 5.64143Z",
    fill: "url(#paint3_linear_61_1395)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.695 23.3712C17.3266 24.2097 12.9311 24.2097 8.56262 23.3712C8.02088 23.2672 7.58312 22.7921 7.44221 22.1632C6.59823 18.3964 6.59818 14.6092 7.44221 10.8423C7.58316 10.2133 8.02088 9.73823 8.56262 9.63426C12.9311 8.79572 17.3266 8.79576 21.695 9.63426C22.2368 9.73823 22.6745 10.2133 22.8154 10.8423C23.6595 14.6092 23.6594 18.3964 22.8154 22.1632C22.6745 22.7921 22.2368 23.2672 21.695 23.3712Z",
    fill: "url(#paint4_linear_61_1395)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5948 16.8792H6.81213C6.83829 18.6422 7.04824 20.4049 7.44218 22.1631C7.58309 22.7921 8.02085 23.2672 8.56259 23.3712C10.5694 23.7564 12.5818 23.9641 14.5948 23.9954V16.8792Z",
    fill: "url(#paint5_linear_61_1395)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5948 16.8792H6.81213C6.83829 18.6422 7.04824 20.4049 7.44218 22.1631C7.58309 22.7921 8.02085 23.2672 8.56259 23.3712C10.5694 23.7564 12.5818 23.9641 14.5948 23.9954V16.8792Z",
    fill: "url(#paint6_linear_61_1395)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8154 10.8423C22.6745 10.2132 22.2368 9.73821 21.695 9.63424C19.099 9.13591 16.4934 8.93379 13.8896 9.02772C15.6674 9.09185 17.4443 9.29402 19.2168 9.63424C19.7585 9.73821 20.1963 10.2133 20.3372 10.8423C21.1812 14.6092 21.1812 18.3964 20.3372 22.1631C20.1963 22.7921 19.7585 23.2672 19.2168 23.3711C17.4444 23.7114 15.6675 23.9135 13.8897 23.9777C16.4935 24.0716 19.099 23.8695 21.695 23.3711C22.2368 23.2672 22.6745 22.7921 22.8154 22.1631C23.6594 18.3964 23.6595 14.6092 22.8154 10.8423Z",
    fill: "url(#paint7_linear_61_1395)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M21.695 9.63423C20.7757 9.45774 19.8552 9.31923 18.934 9.21704V9.58135C19.0282 9.59865 19.1225 9.61618 19.2168 9.63428C19.7585 9.73824 20.1963 10.2133 20.3372 10.8423C21.1812 14.6092 21.1811 18.3964 20.3372 22.1632C20.1962 22.7921 19.7585 23.2672 19.2168 23.3712C19.1225 23.3893 19.0282 23.4068 18.934 23.4241V23.7884C19.8551 23.6862 20.7757 23.5477 21.695 23.3712C22.2368 23.2673 22.6745 22.7922 22.8154 22.1632C23.6594 18.3965 23.6595 14.6093 22.8154 10.8423C22.6745 10.2132 22.2368 9.7382 21.695 9.63423Z",
    fill: "url(#paint8_linear_61_1395)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M7.4422 22.1631C7.58316 22.7921 8.02088 23.2672 8.56261 23.3711C12.9311 24.2096 17.3265 24.2097 21.695 23.3711C22.2368 23.2672 22.6745 22.7921 22.8154 22.1631C23.2374 20.2797 23.4484 18.3912 23.4484 16.5027H6.8092C6.80925 18.3912 7.02024 20.2797 7.4422 22.1631Z",
    fill: "url(#paint9_linear_61_1395)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8896 21.0984C13.0105 21.0984 12.2953 20.3832 12.2953 19.5041V17.9664C12.2953 17.6331 12.1497 17.3223 11.8959 17.1136C11.1338 16.4871 10.7164 15.5621 10.7507 14.5758C10.779 13.7648 11.1186 13.0043 11.7071 12.4344C12.2952 11.865 13.0661 11.5497 13.8776 11.5466H13.8896C15.6214 11.5466 17.0304 12.9556 17.0304 14.6874C17.0304 15.6299 16.6124 16.5142 15.8836 17.1135C15.6296 17.3223 15.4839 17.6332 15.4839 17.9665V19.5041C15.4839 20.3832 14.7687 21.0984 13.8896 21.0984Z",
    fill: "url(#paint10_linear_61_1395)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3532 14.6873C16.3532 13.3235 15.2451 12.2185 13.8801 12.2237C12.5659 12.2286 11.4732 13.2859 11.4274 14.5993C11.3995 15.4016 11.7555 16.1215 12.3258 16.5904C12.7368 16.9283 12.9724 17.4343 12.9724 17.9664V19.504C12.9724 20.0106 13.383 20.4212 13.8895 20.4212C14.3961 20.4212 14.8067 20.0106 14.8067 19.504V17.9992L14.713 17.9664C14.713 17.4342 14.9018 16.8813 15.3128 16.5434C15.7709 16.1668 16.3249 15.062 16.3249 15.062C16.3421 14.9396 16.3532 14.8147 16.3532 14.6873Z",
    fill: "url(#paint11_linear_61_1395)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3532 14.6873C16.3532 13.3235 15.2451 12.2185 13.8801 12.2237C12.5659 12.2286 11.4732 13.2859 11.4274 14.5993C11.3995 15.4016 11.7555 16.1215 12.3258 16.5904C12.7368 16.9283 12.9724 17.4343 12.9724 17.9664V19.504C12.9724 20.0106 13.383 20.4212 13.8895 20.4212C14.3961 20.4212 14.8067 20.0106 14.8067 19.504V17.9992L14.713 17.9664C14.713 17.4342 14.9018 16.8813 15.3128 16.5434C15.7709 16.1668 16.3249 15.062 16.3249 15.062C16.3421 14.9396 16.3532 14.8147 16.3532 14.6873Z",
    fill: "url(#paint12_linear_61_1395)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3532 14.6873C16.3532 13.3235 15.2451 12.2185 13.8801 12.2237C12.5659 12.2286 11.4732 13.2859 11.4274 14.5993C11.3995 15.4016 11.7555 16.1215 12.3258 16.5904C12.7368 16.9283 12.9724 17.4343 12.9724 17.9664V19.504C12.9724 20.0106 13.383 20.4212 13.8895 20.4212C14.3961 20.4212 14.8067 20.0106 14.8067 19.504V17.9992L14.713 17.9664C14.713 17.4342 14.9018 16.8813 15.3128 16.5434C15.7709 16.1668 16.3249 15.062 16.3249 15.062C16.3421 14.9396 16.3532 14.8147 16.3532 14.6873Z",
    fill: "url(#paint13_linear_61_1395)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9596 17.7546C12.9679 17.8245 12.9724 17.8952 12.9724 17.9663V19.504C12.9724 20.0105 13.383 20.4212 13.8895 20.4212C14.3961 20.4212 14.8067 20.0105 14.8067 19.504V17.9991L14.713 17.9663C14.713 17.8959 14.7165 17.8252 14.7232 17.7546H12.9596Z",
    fill: "url(#paint14_linear_61_1395)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9596 17.7546C12.9679 17.8245 12.9724 17.8952 12.9724 17.9663V19.504C12.9724 20.0105 13.383 20.4212 13.8895 20.4212C14.3961 20.4212 14.8067 20.0105 14.8067 19.504V17.9991L14.713 17.9663C14.713 17.8959 14.7165 17.8252 14.7232 17.7546H12.9596Z",
    fill: "url(#paint15_linear_61_1395)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M2.7862 17.3295C2.22979 17.3295 1.77885 16.8786 1.77885 16.3227C1.77885 15.7663 2.22979 15.3158 2.7862 15.3158C3.34213 15.3158 3.79307 15.7663 3.79307 16.3227C3.79307 16.8786 3.34213 17.3295 2.7862 17.3295ZM9.8856 15.062C9.12951 15.062 8.42076 14.6875 7.99935 14.0594C7.27185 12.9751 6.03763 12.2603 4.6356 12.2547C2.43341 12.2462 0.604352 14.0228 0.55279 16.2245C0.498884 18.5158 2.34013 20.3898 4.61967 20.3898C5.90216 20.3898 7.04592 19.7964 7.79123 18.8687C8.22904 18.3245 8.88295 17.9992 9.58138 17.9992H14.8065V17.9664C14.8065 17.4344 15.0423 16.9281 15.4534 16.5901C15.9114 16.2137 16.2315 15.6747 16.3248 15.062H9.8856Z",
    fill: "url(#paint16_linear_61_1395)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M5.8963 18.1358C5.55505 18.1358 5.27844 17.8592 5.27844 17.5179V15.1264C5.27844 14.7852 5.55505 14.5085 5.8963 14.5085C6.23755 14.5085 6.51416 14.7852 6.51416 15.1264V17.5179C6.51421 17.8592 6.23755 18.1358 5.8963 18.1358Z",
    fill: "url(#paint17_linear_61_1395)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M3.7619 16.0781C3.78149 16.1565 3.79302 16.2382 3.79302 16.3226C3.79302 16.8786 3.34209 17.3295 2.78615 17.3295C2.22974 17.3295 1.77881 16.8786 1.77881 16.3226C1.77881 16.2381 1.79034 16.1565 1.80993 16.0781H0.559915C0.557009 16.1268 0.553915 16.1754 0.55279 16.2245C0.498884 18.5158 2.34013 20.3898 4.61967 20.3898C5.90216 20.3898 7.04592 19.7964 7.79123 18.8687C8.22904 18.3245 8.88295 17.9992 9.58138 17.9992H14.8065V17.9664C14.8065 17.4344 15.0423 16.9281 15.4534 16.5901C15.6328 16.4427 15.7906 16.2701 15.9223 16.0781H3.7619Z",
    fill: "url(#paint18_linear_61_1395)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M2.78614 14.8901C1.99489 14.8901 1.35364 15.5314 1.35364 16.3226C1.35364 17.1134 1.99489 17.7547 2.78614 17.7547C3.57692 17.7547 4.21817 17.1134 4.21817 16.3226C4.21817 15.5314 3.57692 14.8901 2.78614 14.8901ZM2.78614 17.1139C2.34879 17.1139 1.99489 16.7595 1.99489 16.3226C1.99489 15.8858 2.34879 15.5314 2.78614 15.5314C3.22301 15.5314 3.57739 15.8858 3.57739 16.3226C3.57739 16.7595 3.22301 17.1139 2.78614 17.1139Z",
    fill: "url(#paint19_linear_61_1395)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M9.6882 15.6538C9.45383 15.6538 9.26379 15.8438 9.26379 16.0782C9.26379 16.3126 9.45378 16.5026 9.6882 16.5026H15.5537C15.8103 16.2674 16.0167 15.9785 16.1555 15.6538H9.6882Z",
    fill: "url(#paint20_linear_61_1395)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0534 16.7205C10.8853 16.7205 10.7489 16.8569 10.7489 17.0251C10.7489 17.1932 10.8853 17.3296 11.0534 17.3296H14.924C15.0099 17.1035 15.1409 16.8956 15.3119 16.7205H11.0534V16.7205Z",
    fill: "url(#paint21_linear_61_1395)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4259 17.9992H14.8065V17.9664C14.8065 17.4344 15.0423 16.9281 15.4534 16.5901C15.9113 16.2137 16.2315 15.6747 16.3248 15.062H11.4259V17.9992Z",
    fill: "url(#paint22_linear_61_1395)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_61_1395",
    x1: 11.4315,
    y1: 1.17966,
    x2: 13.6975,
    y2: 5.00902,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EAF9FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B3DAFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_61_1395",
    x1: 17.7102,
    y1: 3.71878,
    x2: 20.7606,
    y2: 3.71878,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7BACDF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7BACDF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_61_1395",
    x1: 10.4999,
    y1: 8.22921,
    x2: 10.4999,
    y2: 11.1778,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7BACDF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7BACDF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_61_1395",
    x1: 19.7576,
    y1: 6.3394,
    x2: 19.7576,
    y2: 7.46599,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7BACDF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7BACDF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_61_1395",
    x1: 11.7367,
    y1: 10.8563,
    x2: 18.5057,
    y2: 22.1236,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEF0AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBC56D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_61_1395",
    x1: 11.7188,
    y1: 20.5232,
    x2: 9.17918,
    y2: 17.4489,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC8758",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2153,
    stopColor: "#DD8654",
    stopOpacity: 0.215
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4291,
    stopColor: "#E28448",
    stopOpacity: 0.429
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6424,
    stopColor: "#EA8034",
    stopOpacity: 0.642
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8543,
    stopColor: "#F47B18",
    stopOpacity: 0.854
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE7701"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_61_1395",
    x1: 10.7035,
    y1: 19.0624,
    x2: 10.7035,
    y2: 17.9156,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC8758",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2153,
    stopColor: "#DD8654",
    stopOpacity: 0.215
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4291,
    stopColor: "#E28448",
    stopOpacity: 0.429
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6424,
    stopColor: "#EA8034",
    stopOpacity: 0.642
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8543,
    stopColor: "#F47B18",
    stopOpacity: 0.854
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE7701"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_61_1395",
    x1: 6.79638,
    y1: 6.24696,
    x2: 27.6212,
    y2: 25.9877,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC8758",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2153,
    stopColor: "#DD8654",
    stopOpacity: 0.215
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4291,
    stopColor: "#E28448",
    stopOpacity: 0.429
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6424,
    stopColor: "#EA8034",
    stopOpacity: 0.642
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8543,
    stopColor: "#F47B18",
    stopOpacity: 0.854
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE7701"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_61_1395",
    x1: 21.2315,
    y1: 16.5027,
    x2: 23.1425,
    y2: 16.5027,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC8758",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2153,
    stopColor: "#DD8654",
    stopOpacity: 0.215
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4291,
    stopColor: "#E28448",
    stopOpacity: 0.429
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6424,
    stopColor: "#EA8034",
    stopOpacity: 0.642
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8543,
    stopColor: "#F47B18",
    stopOpacity: 0.854
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE7701"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_61_1395",
    x1: 15.1288,
    y1: 19.7201,
    x2: 15.1288,
    y2: 24.0978,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC8758",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2153,
    stopColor: "#DD8654",
    stopOpacity: 0.215
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4291,
    stopColor: "#E28448",
    stopOpacity: 0.429
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6424,
    stopColor: "#EA8034",
    stopOpacity: 0.642
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8543,
    stopColor: "#F47B18",
    stopOpacity: 0.854
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE7701"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_61_1395",
    x1: 13.0113,
    y1: 15.683,
    x2: 9.88984,
    y2: 13.8487,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC8758",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2153,
    stopColor: "#DD8654",
    stopOpacity: 0.215
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4291,
    stopColor: "#E28448",
    stopOpacity: 0.429
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6424,
    stopColor: "#EA8034",
    stopOpacity: 0.642
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8543,
    stopColor: "#F47B18",
    stopOpacity: 0.854
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE7701"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_61_1395",
    x1: 12.3257,
    y1: 16.3224,
    x2: 15.3364,
    y2: 16.3224,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A5A5A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#444444"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_61_1395",
    x1: 13.1122,
    y1: 16.3224,
    x2: 11.2501,
    y2: 16.3224,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#433F43",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A1A1A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_61_1395",
    x1: 13.5712,
    y1: 15.113,
    x2: 12.1844,
    y2: 12.8742,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#433F43",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A1A1A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_61_1395",
    x1: 13.7972,
    y1: 19.0879,
    x2: 12.9611,
    y2: 19.0879,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#433F43",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A1A1A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_61_1395",
    x1: 13.8832,
    y1: 19.257,
    x2: 13.8832,
    y2: 17.9652,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#433F43",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A1A1A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_61_1395",
    x1: 4.48912,
    y1: 12.5855,
    x2: 10.8095,
    y2: 18.9059,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEF0AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBC56D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_61_1395",
    x1: 6.48144,
    y1: 16.3222,
    x2: 5.27108,
    y2: 16.3222,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEF0AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBC56D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_61_1395",
    x1: 8.43792,
    y1: 17.3392,
    x2: 8.99484,
    y2: 19.8788,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC8758",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2153,
    stopColor: "#DD8654",
    stopOpacity: 0.215
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4291,
    stopColor: "#E28448",
    stopOpacity: 0.429
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6424,
    stopColor: "#EA8034",
    stopOpacity: 0.642
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8543,
    stopColor: "#F47B18",
    stopOpacity: 0.854
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE7701"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_61_1395",
    x1: 3.67001,
    y1: 17.2065,
    x2: 1.83992,
    y2: 15.3764,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEF0AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBC56D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_61_1395",
    x1: 12.7097,
    y1: 16.4558,
    x2: 12.7097,
    y2: 15.671,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEF0AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBC56D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_61_1395",
    x1: 13.0304,
    y1: 17.3246,
    x2: 13.0304,
    y2: 16.8104,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEF0AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBC56D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_61_1395",
    x1: 13.4214,
    y1: 16.2614,
    x2: 15.3372,
    y2: 17.3975,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC8758",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2153,
    stopColor: "#DD8654",
    stopOpacity: 0.215
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4291,
    stopColor: "#E28448",
    stopOpacity: 0.429
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6424,
    stopColor: "#EA8034",
    stopOpacity: 0.642
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8543,
    stopColor: "#F47B18",
    stopOpacity: 0.854
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE7701"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnlockModalIcon);
export default __webpack_public_path__ + "static/media/unlock_modal_icon.8b1e8debefb31fd17d5fb78a4792f085.svg";
export { ForwardRef as ReactComponent };